export default __webpack_public_path__ + "d61a9cad4969797b4084c14b6b89bc4d.svg";